// THIS WILL BE AUTO-UPDATED BY RELEASE-PLEASE!
// If you move this file you need to update the release please configuration paths

// x-release-please-start-version
export const VERSION = '3.29.0+next';
// x-release-please-end

declare const __GIT_HASH__: string | undefined;
// Declared locally, not via @types/node: this lib is bundled for the browser
// too, where process doesn't exist at all.
declare const process: { env?: { GIT_HASH?: string } } | undefined;

// Server bundles read the hash from the env at runtime (set by helm or the
// deploy script) so they stay byte-identical across commits; browser bundles
// use the build-time define.
const runtimeGitHash = typeof process === 'undefined' ? undefined : process?.env?.GIT_HASH;
const buildGitHash = typeof __GIT_HASH__ === 'undefined' ? '' : String(__GIT_HASH__);

export const GIT_HASH = (runtimeGitHash ?? buildGitHash).trim();

export const NORA_DISPLAY_VERSION = `NORA v${VERSION}${GIT_HASH ? `-${GIT_HASH}` : ''}`;
